import e from "react";
import a from "classnames";
import o from "./loading.module.scss.js";
function m({
  design: r = {
    color: "#EA565C",
    backgroundColor: "#FFF"
  },
  text: l = "",
  fullScreen: t = !0
}) {
  return /* @__PURE__ */ e.createElement(
    "div",
    {
      "data-testid": "loading",
      className: a({
        [o.loadingIoSpinner]: !0,
        [o.fullScreen]: t
      }),
      style: { backgroundColor: r.backgroundColor }
    },
    /* @__PURE__ */ e.createElement("div", { className: o.loadingIo }, /* @__PURE__ */ e.createElement("div", { style: { borderColor: r.color } }), /* @__PURE__ */ e.createElement("div", { style: { borderColor: r.color } })),
    l && l.length > 0 && /* @__PURE__ */ e.createElement("div", { className: o.text }, l)
  );
}
export {
  m as Loading
};
//# sourceMappingURL=Loading.js.map
